import React, { createContext, useContext, useMemo } from "react";

import { useParams } from "react-router-dom";

export interface MenuScope {
    menuId: number;
}

const MenuScopeContext = createContext<MenuScope | null>(null);

export const useMenuScope = (): MenuScope => {
    const scope = useContext(MenuScopeContext);

    if (!scope) {
        throw new Error("useMenuScope вызван вне MenuScopeProvider");
    }

    return scope;
};

/*
* Меню, в рамках которого сейчас работает кабинет. Экраны берут menuId отсюда и о роуте
* ничего не знают: когда выбор меню переедет в селект шапки, поменяется только этот
* провайдер, а фичи не тронутся. На форму REST-путей это не влияет: коллекции фильтруются
* по нему (`/menu-categories?menuId=`), синглтон-подресурсы меню его вкладывают
* (`/menus/{menuId}/iiko-integration`) — в обоих случаях id приходит из скоупа.
* */
export const MenuScopeFromRouteProvider = ({ children }: { children: React.ReactNode }) => {
    const { menuId } = useParams<{ menuId: string }>();
    const value = useMemo<MenuScope>(() => ({ menuId: Number(menuId) }), [menuId]);

    return <MenuScopeContext.Provider value={value}>{children}</MenuScopeContext.Provider>;
};
